export default "__VITE_ASSET__DTyWh_H$__"